import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { SEARCH_TYPE } from 'app/constants/search';
import { EmptySearchList } from 'app/components/blog/search';
import useIsMobile from 'app/utils/hooks/useIsMobile';
import ProfileList from 'app/components/profile/ProfileList';
import OpinionList from 'app/components/opinion/OpinionList';
import ProductSearchList from 'app/components/product/ProductSearchList';
import scrollTo from 'app/utils/scrollTo';
import ArticleList from 'app/components/blog/ArticleList';
import JoinGroupList from 'app/components/group/JoinGroupList';
import PostList from '../../components/post/PostList';
import SearchListWrapper from './SearchListWrapper';
import SearchCategoryCardList from './SearchCategoryCardList';
import * as S from './styles';

const AllResults = props => {
  const {
    searchTerm,
    setSelectedFilter,
    productCategoryResult,
    groupResult,
    articleResult = [],
    articlePagination,
  } = props;

  const countBySearchType = useSelector(state => {
    return {
      [SEARCH_TYPE.QUESTION]: state.post.pagination.totalCount,
      [SEARCH_TYPE.PROFILE]: state.profile.meta.pagination.totalCount,
      [SEARCH_TYPE.PRODUCT]: state.product.meta.pagination.totalCount,
      [SEARCH_TYPE.OPINION]: state.opinion.pagination.totalCount,
    };
  }, shallowEqual);
  const isMobile = useIsMobile();
  const products = useSelector(state => state.product.products, shallowEqual);
  const productCategories = useSelector(
    state => state.product.productCategoriesById,
  );
  const profileIds = useSelector(state => state.profile.meta.ids);
  const searchedQuestionIds = useSelector(
    state => state.post.ids,
    shallowEqual,
  );
  const searchedOpinionIds = useSelector(
    state => state.opinion.ids,
    shallowEqual,
  );

  const listLimit = isMobile ? 2 : 3;
  const categories = productCategoryResult.map(result => {
    return productCategories[result.id];
  });

  return (
    <S.SearchResultContainer>
      <div style={{ marginBottom: '26px' }}>
        <SearchCategoryCardList categories={categories} />
      </div>
      {groupResult.length > 0 && (
        <SearchListWrapper
          type="Groups"
          count={groupResult.length}
          term={searchTerm}
          onSeeAllClick={() => {
            scrollTo({ top: 0 });
            setSelectedFilter(SEARCH_TYPE.GROUP);
          }}
        >
          <div className="bg-white p-4 h-fit w-full rounded-lg">
            <JoinGroupList groupList={groupResult.slice(0, 3)} />
          </div>
        </SearchListWrapper>
      )}
      {products.length > 0 && (
        <SearchListWrapper
          type="Products"
          count={countBySearchType[SEARCH_TYPE.PRODUCT]}
          term={searchTerm}
          onSeeAllClick={() => {
            scrollTo({ top: 0 });
            setSelectedFilter(SEARCH_TYPE.PRODUCT);
          }}
        >
          <ProductSearchList searchTerm={searchTerm} limit={listLimit} />
        </SearchListWrapper>
      )}
      {articleResult.length > 0 && (
        <SearchListWrapper
          type="Articles"
          count={articlePagination.total}
          term={searchTerm}
          onSeeAllClick={() => {
            scrollTo({ top: 0 });
            setSelectedFilter(SEARCH_TYPE.ARTICLE);
          }}
        >
          <ArticleList
            articles={articleResult.slice(0, listLimit)}
            loading={false}
            currentPage={1}
            totalPage={1}
            renderEmptyList={() => <EmptySearchList />}
          />
        </SearchListWrapper>
      )}
      {searchedOpinionIds.length > 0 && (
        <SearchListWrapper
          type="Opinions"
          count={countBySearchType[SEARCH_TYPE.OPINION]}
          term={searchTerm}
          onSeeAllClick={() => {
            scrollTo({ top: 0 });
            setSelectedFilter(SEARCH_TYPE.OPINION);
          }}
        >
          <OpinionList opinionItemProps={{ withComment: false }} />
        </SearchListWrapper>
      )}
      {searchedQuestionIds.length > 0 && (
        <SearchListWrapper
          type="Discussions"
          count={countBySearchType[SEARCH_TYPE.QUESTION]}
          term={searchTerm}
          onSeeAllClick={() => {
            scrollTo({ top: 0 });
            setSelectedFilter(SEARCH_TYPE.QUESTION);
          }}
        >
          <PostList limitPost={listLimit} />
        </SearchListWrapper>
      )}
      {profileIds.length > 0 && (
        <SearchListWrapper
          type="Profiles"
          count={countBySearchType[SEARCH_TYPE.PROFILE]}
          term={searchTerm}
          onSeeAllClick={() => {
            scrollTo({ top: 0 });
            setSelectedFilter(SEARCH_TYPE.PROFILE);
          }}
        >
          <ProfileList profileIds={profileIds.slice(0, 4)} />
        </SearchListWrapper>
      )}
    </S.SearchResultContainer>
  );
};

export default AllResults;
